import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useWallet() {
  const [wallet, setWallet] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.members.wallet.show)
      .then((response) => {
        setWallet(response.data.data);
      });
  }, []);

  return wallet;
}
